package er.prateek.crossly.config

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * The `streak` section of [AppConfig]: how a lost any-game streak can be bought back.
 *
 * A streak "breaks" at the local midnight that ends the first fully-missed day. From that
 * moment the player has [restoreWindowHours] to restore it: within the first
 * [graceHours] it costs [adsWithinGrace] rewarded ad(s), after that [adsAfterGrace]. Players
 * who can't be shown a rewarded ad (desktop/web, no fill) may pay [starCostPerAd] stars per ad
 * instead; ad-free players restore for free.
 */
@Serializable
data class StreakConfig(
    @SerialName("restore_enabled") val restoreEnabled: Boolean = true,
    /** Streaks shorter than this aren't worth a restore prompt. */
    @SerialName("min_streak_to_restore") val minStreakToRestore: Int = 2,
    @SerialName("grace_hours") val graceHours: Int = 24,
    @SerialName("restore_window_hours") val restoreWindowHours: Int = 72,
    @SerialName("ads_within_grace") val adsWithinGrace: Int = 1,
    @SerialName("ads_after_grace") val adsAfterGrace: Int = 2,
    /** `0` disables the star fallback. */
    @SerialName("star_cost_per_ad") val starCostPerAd: Int = 10,
)
